import { createFileRoute } from '@tanstack/react-router'
import { LegalPage } from '@/components/landing/legal-page'

export const Route = createFileRoute('/terms')({
  component: Terms,
  head: () => ({
    meta: [
      { title: 'Terms of Service | Vello' },
      {
        name: 'description',
        content:
          'Terms that govern purchases of Vello Launch and Vello+ retainer.',
      },
    ],
    links: [{ rel: 'canonical', href: 'https://withvello.com/terms' }],
  }),
})

function Terms() {
  return (
    <LegalPage
      eyebrow="Legal"
      title="Terms of Service"
      updated="April 19, 2026"
    >
      <p>
        These terms cover your purchase and use of Vello services, including
        Vello Launch (a one-time website build) and Vello+ (a monthly retainer).
        By paying through Stripe Checkout on withvello.com you agree to them.
      </p>

      <h2>What you&apos;re buying</h2>
      <p>
        <strong>Vello Launch, $1,999, one-time.</strong> A 5-page custom website
        designed, built, and deployed on a domain you own. Work starts after
        payment and the intake form is submitted. Vello targets a 7-day
        turnaround from a completed intake to a live site, contingent on you
        responding to drafts within 48 hours. One revision pass is included.
      </p>
      <p>
        <strong>Vello+, $299 per month.</strong> An optional retainer for
        ongoing edits, new pages, and light hosting support. One active request
        at a time, 48-hour turnaround per request, cancel anytime. Billing
        repeats monthly until you cancel.
      </p>

      <h2>Payment and refunds</h2>
      <p>
        Payments are processed by Stripe. Prices are in USD. Vello does not
        store your card details. If you cancel Vello Launch within 48 hours of
        payment, before design work has started, you get a full refund, no
        questions. After design work starts the purchase is non-refundable
        except under the guarantee below.
      </p>
      <p>
        <strong>Design guarantee.</strong> If the first round of design misses
        the brief, tell Thijs in writing and a redesign follows at no extra
        cost. If round two still does not land, Vello refunds your Launch fee
        in full.
      </p>
      <p>
        <strong>Vello+ cancellation.</strong> Cancel any time from the link in
        your billing receipt or by emailing hello@withvello.com. Cancellation
        takes effect at the end of the current billing period. Partial months
        are not prorated.
      </p>

      <h2>Ownership</h2>
      <p>
        Once the Launch fee is paid in full, the design files and the site code
        are yours. You keep the domain, the CRM data, and the content. If you
        cancel Vello+ the repository is handed off to you or your developer.
      </p>

      <h2>What is needed from you</h2>
      <p>
        A completed intake form, any logo or brand assets you want used, and
        timely responses to drafts. The 7-day delivery only holds if the intake
        is submitted promptly and you review the first draft within 48 hours.
        Long response windows extend the timeline.
      </p>

      <h2>Acceptable use</h2>
      <p>
        Vello does not build sites for anything illegal, deceptive, or harmful,
        and reserves the right to decline or stop work and refund unbilled
        amounts if a project falls outside acceptable use.
      </p>

      <h2>Liability</h2>
      <p>
        Vello&apos;s total liability to you for any claim is limited to the
        amount paid to Vello in the 12 months preceding the claim. Vello is not
        liable for lost profits, lost revenue, or indirect damages. Some
        jurisdictions don&apos;t allow these limits, in which case the limits
        apply to the extent permitted.
      </p>

      <h2>Changes</h2>
      <p>
        These terms may be updated. The &ldquo;Last updated&rdquo; date at the
        top reflects the most recent version. Continued use of Vello services
        after an update means you accept the updated terms.
      </p>

      <h2>Contact</h2>
      <p>
        Questions, notices, or disputes:{' '}
        <a href="mailto:hello@withvello.com">hello@withvello.com</a>.
      </p>
    </LegalPage>
  )
}

